module.exports = __webpack_public_path__ + "static/media/dad.0acabf5b.jpg";